import React from "react";
import PageHeader from "../components/PageHeader";
import { Calendar, MapPin, Clock, Ticket } from "lucide-react";

const events = [
  {
    title: "What the Healthcare, Canada?",
    speaker: "Shannon Knelsen",
    date: "Wednesday, July 29th, 2026",
    time: "6:00 PM — 8:00 PM",
    venue: "TWB Brewing",
    location: "Kitchener, ON",
    price: "$15 CAD",
    url: "https://shop.twbbrewing.com/product/brains-on-tap-july-12-/BGTGWQW3UFU2H7EFR3OPEPAM",
    featured: true,
  },
  {
    title: "Are lectures really the best way for us to learn?",
    speaker: "Sean Geobey",
    date: "Wednesday, August 26th, 2026",
    time: "6:00 PM — 8:00 PM",
    venue: "TWB Brewing",
    location: "Kitchener, ON",
    price: "$15 CAD",
    url: "#",
  },
  {
    title: "The History of LEGO & the Power of Play in Adulthood",
    speaker: "TBA",
    date: "Wednesday, September 30th, 2026",
    time: "6:00 PM — 8:00 PM",
    venue: "TWB Brewing",
    location: "Kitchener, ON",
    price: "$15 CAD",
    url: "#",
  },
];

const BotEvents = () => {
  return (
    <div>
      <PageHeader
        title="Upcoming BOT Events"
        subtitle="Grab a pint, pull up a chair, and let's nerd out together."
      />
      <section className="py-20 px-6">
        <div className="max-w-5xl mx-auto space-y-6">
          {events.map((e) => (
            <div
              key={e.title}
              className={`bg-[#181818] border ${
                e.featured ? "border-[#e8a13a]/60" : "border-[#2a2a2a]"
              } p-8 grid md:grid-cols-3 gap-6 items-center hover:border-[#e8a13a] transition-colors`}
            >
              <div className="md:col-span-2">
                {e.featured && (
                  <span className="inline-block bg-[#e8a13a] text-[#0f0f10] px-3 py-1 text-xs tracking-widest font-bold mb-3">
                    NEXT UP
                  </span>
                )}
                <h3 className="font-display text-2xl md:text-3xl text-[#f5f1e8] mb-2">
                  {e.title}
                </h3>
                <p className="text-[#e8a13a] font-serif-italic text-lg mb-4">
                  with {e.speaker}
                </p>
                <div className="grid sm:grid-cols-2 gap-2 text-sm text-[#d5c9a8]">
                  <div className="flex items-center gap-2">
                    <Calendar className="w-4 h-4 text-[#e8a13a]" /> {e.date}
                  </div>
                  <div className="flex items-center gap-2">
                    <Clock className="w-4 h-4 text-[#e8a13a]" /> {e.time}
                  </div>
                  <div className="flex items-center gap-2">
                    <MapPin className="w-4 h-4 text-[#e8a13a]" /> {e.venue}, {e.location}
                  </div>
                  <div className="flex items-center gap-2">
                    <Ticket className="w-4 h-4 text-[#e8a13a]" /> {e.price}
                  </div>
                </div>
              </div>
              <div className="md:text-right">
                <a
                  href={e.url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-block border-2 border-[#e8a13a] text-[#e8a13a] hover:bg-[#e8a13a] hover:text-[#0f0f10] px-6 py-3 text-sm tracking-widest font-semibold transition-colors"
                >
                  GET TICKETS
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default BotEvents;
